// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5fdb2901","66":"ef49a600","398":"1ed92fce","429":"f798f8c4","453":"17e6af64","463":"91118ffa","504":"cf6e14f3","615":"181ae0a2","624":"385f8937","687":"43a62c6f","752":"38346b54","818":"098df218","841":"55044402","846":"4f9811d2","936":"a9715c54"}[chunkId] + ".chunk.js";
};